import { render, staticRenderFns } from "./GasView.vue?vue&type=template&id=251cba39&scoped=true&"
import script from "./GasView.vue?vue&type=script&lang=js&"
export * from "./GasView.vue?vue&type=script&lang=js&"
import style0 from "./GasView.vue?vue&type=style&index=0&id=251cba39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251cba39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
